import { render, staticRenderFns } from "./ZaloTodo.vue?vue&type=template&id=142b2661&scoped=true"
import script from "./ZaloTodo.vue?vue&type=script&lang=js"
export * from "./ZaloTodo.vue?vue&type=script&lang=js"
import style0 from "./ZaloTodo.vue?vue&type=style&index=0&id=142b2661&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142b2661",
  null
  
)

export default component.exports